import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { api } from '../services/api';
import LazyImage from '../components/LazyImage';
import { RotatingLines } from 'react-loader-spinner';
import { FaTimes } from 'react-icons/fa';

const Container = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.large};
  margin: 0 auto;
  padding: 2rem;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: ${({ theme }) => theme.colors.secondary};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
`;

const GalleryItem = styled.div`
  position: relative;
  height: 250px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: ${({ theme }) => theme.shadows.small};
  
  &:hover img {
    transform: scale(1.05);
  }
`;

const LightboxOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.9);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const LightboxImage = styled.img`
  max-width: 90%;
  max-height: 80vh;
  border-radius: 4px;
`;

const LightboxCaption = styled.p`
  color: white;
  margin-top: 1rem;
  font-size: 1.2rem;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 2rem;
  right: 2rem;
  background: transparent;
  border: none;
  color: white;
  font-size: 2rem;
  cursor: pointer;
`;

const Gallery = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [imgLoading, setImgLoading] = useState(true);

  useEffect(() => {
    api.get('/gallery')
      .then(setItems)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = (item) => {
    setSelectedItem(item);
    setImgLoading(true);
  };

  const getImageUrl = (src) => src && src.startsWith('/') ? `${process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '')}${src}` : src;

  if (loading) return (
    <div style={{display:'flex', justifyContent:'center', marginTop:'50px', minHeight:'100vh'}}>
      <RotatingLines strokeColor="grey" width="50" />
    </div>
  );

  return (
    <Container>
      <PageHeader>
        <Title>Gallery</Title>
        <p>Moments from our ministry.</p>
      </PageHeader>

      <Grid>
        {items.map((item) => (
          <GalleryItem key={item._id} onClick={() => handleSelect(item)}>
             <LazyImage src={item.image} alt={item.caption} />
          </GalleryItem>
        ))}
      </Grid>
      {items.length === 0 && <p style={{textAlign:'center'}}>No images found.</p>}

      {selectedItem && (
        <LightboxOverlay onClick={() => setSelectedItem(null)}>
          <CloseButton onClick={() => setSelectedItem(null)}><FaTimes /></CloseButton>
          {imgLoading && (
             <div style={{position: 'absolute', zIndex: 2001}}>
                <RotatingLines strokeColor="white" width="50" />
             </div>
          )}
          <LightboxImage 
            src={getImageUrl(selectedItem.image)} 
            alt={selectedItem.caption} 
            onClick={(e) => e.stopPropagation()} 
            onLoad={() => setImgLoading(false)}
            style={{display: imgLoading ? 'none' : 'block'}}
          />
          {!imgLoading && selectedItem.caption && <LightboxCaption>{selectedItem.caption}</LightboxCaption>}
        </LightboxOverlay>
      )}
    </Container>
  );
};

export default Gallery;
